// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Js_array = require("@rescript/runtime/lib/js/Js_array.js");
let Belt_Array = require("@rescript/runtime/lib/js/Belt_Array.js");
let ReactDOMStyle = require("@rescript/react/src/ReactDOMStyle.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function pxToString(p) {
  if (p === "p6") {
    return "6px";
  } else if (p === "p8") {
    return "8px";
  } else if (p === "p10") {
    return "10px";
  } else if (p === "p12") {
    return "12px";
  } else if (p === "p16") {
    return "16px";
  } else if (p === "p20") {
    return "20px";
  } else if (p === "p24") {
    return "24px";
  } else if (p === "p32") {
    return "32px";
  } else if (p === "p48") {
    return "48px";
  } else {
    return "5px";
  }
}

function percentToString(p) {
  return "100%";
}

function wpxToString(w) {
  return "320px";
}

function $$eval(x) {
  if (x.NAME === "px") {
    return "320px";
  } else {
    return "100%";
  }
}

let Width = {
  wpxToString: wpxToString,
  $$eval: $$eval
};

function $$eval$1(x) {
  return "100%";
}

function map(t) {
  return Stdlib_Option.map(t, $$eval$1);
}

let FlexBasis = {
  $$eval: $$eval$1,
  map: map
};

function ViewStack(props) {
  let children = props.children;
  let flexBasis = props.flexBasis;
  let flexGrow = props.flexGrow;
  let flexDirection = props.flexDirection;
  let justifyContent = props.justifyContent;
  let alignItems = props.alignItems;
  let __space = props.space;
  let px = props.px;
  let pb = props.pb;
  let pt = props.pt;
  let p = props.p;
  let mt = props.mt;
  let space = __space !== undefined ? __space : "md";
  let alignBase = v => {
    if (v === "stretch") {
      return "items-stretch";
    } else if (v === "center") {
      return "items-center";
    } else if (v === "baseline") {
      return "items-baseline";
    } else if (v === "flexStart") {
      return "items-start";
    } else if (v === "flexEnd") {
      return "items-end";
    } else {
      return "";
    }
  };
  let alignSm = v => {
    if (v === "stretch") {
      return "sm:items-stretch";
    } else if (v === "center") {
      return "sm:items-center";
    } else if (v === "baseline") {
      return "sm:items-baseline";
    } else if (v === "flexStart") {
      return "sm:items-start";
    } else if (v === "flexEnd") {
      return "sm:items-end";
    } else {
      return "";
    }
  };
  let alignMd = v => {
    if (v === "stretch") {
      return "md:items-stretch";
    } else if (v === "center") {
      return "md:items-center";
    } else if (v === "baseline") {
      return "md:items-baseline";
    } else if (v === "flexStart") {
      return "md:items-start";
    } else if (v === "flexEnd") {
      return "md:items-end";
    } else {
      return "";
    }
  };
  let alignLg = v => {
    if (v === "stretch") {
      return "lg:items-stretch";
    } else if (v === "center") {
      return "lg:items-center";
    } else if (v === "baseline") {
      return "lg:items-baseline";
    } else if (v === "flexStart") {
      return "lg:items-start";
    } else if (v === "flexEnd") {
      return "lg:items-end";
    } else {
      return "";
    }
  };
  let alignXl = v => {
    if (v === "stretch") {
      return "xl:items-stretch";
    } else if (v === "center") {
      return "xl:items-center";
    } else if (v === "baseline") {
      return "xl:items-baseline";
    } else if (v === "flexStart") {
      return "xl:items-start";
    } else if (v === "flexEnd") {
      return "xl:items-end";
    } else {
      return "";
    }
  };
  let align2xl = v => {
    if (v === "stretch") {
      return "2xl:items-stretch";
    } else if (v === "center") {
      return "2xl:items-center";
    } else if (v === "baseline") {
      return "2xl:items-baseline";
    } else if (v === "flexStart") {
      return "2xl:items-start";
    } else if (v === "flexEnd") {
      return "2xl:items-end";
    } else {
      return "";
    }
  };
  let justifyBase = v => {
    if (v === "spaceAround") {
      return "justify-around";
    } else if (v === "center") {
      return "justify-center";
    } else if (v === "spaceBetween") {
      return "justify-between";
    } else if (v === "flexStart") {
      return "justify-start";
    } else if (v === "flexEnd") {
      return "justify-end";
    } else {
      return "";
    }
  };
  let dirBase = v => {
    if (v === "column") {
      return "flex-col";
    } else if (v === "row") {
      return "flex-row";
    } else {
      return "";
    }
  };
  let dirSm = v => {
    if (v === "column") {
      return "sm:flex-col";
    } else if (v === "row") {
      return "sm:flex-row";
    } else {
      return "";
    }
  };
  let dirMd = v => {
    if (v === "column") {
      return "md:flex-col";
    } else if (v === "row") {
      return "md:flex-row";
    } else {
      return "";
    }
  };
  let dirLg = v => {
    if (v === "column") {
      return "lg:flex-col";
    } else if (v === "row") {
      return "lg:flex-row";
    } else {
      return "";
    }
  };
  let dirXl = v => {
    if (v === "column") {
      return "xl:flex-col";
    } else if (v === "row") {
      return "xl:flex-row";
    } else {
      return "";
    }
  };
  let dir2xl = v => {
    if (v === "column") {
      return "2xl:flex-col";
    } else if (v === "row") {
      return "2xl:flex-row";
    } else {
      return "";
    }
  };
  let optStrToArr = opt => {
    if (opt !== undefined) {
      if (opt === "") {
        return [];
      } else {
        return [opt];
      }
    } else {
      return [];
    }
  };
  let mapPadToken = (prefix, v) => {
    switch (prefix) {
      case "p" :
        if (v === "lg") {
          return "p-8";
        } else if (v === "md") {
          return "p-4";
        } else if (v === "sm") {
          return "p-2";
        } else {
          return;
        }
      case "pb" :
        if (v === "md") {
          return "pb-4";
        } else if (v === "xl") {
          return "pb-16";
        } else {
          return;
        }
      case "pt" :
        if (v === "md") {
          return "pt-4";
        } else if (v === "sm") {
          return "pt-2";
        } else {
          return;
        }
      case "px" :
        if (v === "md") {
          return "px-4";
        } else {
          return;
        }
      default:
        return;
    }
  };
  let hasFlexProps = Stdlib_Option.isSome(flexDirection) || Stdlib_Option.isSome(alignItems) || Stdlib_Option.isSome(justifyContent) || Stdlib_Option.isSome(flexBasis);
  let baseTokenX = v => {
    if (v === "zero") {
      return "[&>*:not(:last-child)]:mr-0";
    } else if (v === "lg") {
      return "[&>*:not(:last-child)]:mr-8";
    } else if (v === "md") {
      return "[&>*:not(:last-child)]:mr-4";
    } else if (v === "sm") {
      return "[&>*:not(:last-child)]:mr-2";
    } else if (v === "xs") {
      return "[&>*:not(:last-child)]:mr-1";
    } else {
      return "";
    }
  };
  let baseTokenY = v => {
    if (v === "zero") {
      return "[&>*:not(:last-child)]:mb-0";
    } else if (v === "lg") {
      return "[&>*:not(:last-child)]:mb-8";
    } else if (v === "md") {
      return "[&>*:not(:last-child)]:mb-4";
    } else if (v === "sm") {
      return "[&>*:not(:last-child)]:mb-2";
    } else if (v === "xs") {
      return "[&>*:not(:last-child)]:mb-1";
    } else {
      return "";
    }
  };
  let smTokenX = v => {
    if (v === "zero") {
      return "sm:[&>*:not(:last-child)]:mr-0";
    } else if (v === "lg") {
      return "sm:[&>*:not(:last-child)]:mr-8";
    } else if (v === "md") {
      return "sm:[&>*:not(:last-child)]:mr-4";
    } else if (v === "sm") {
      return "sm:[&>*:not(:last-child)]:mr-2";
    } else if (v === "xs") {
      return "sm:[&>*:not(:last-child)]:mr-1";
    } else {
      return "";
    }
  };
  let smTokenY = v => {
    if (v === "zero") {
      return "sm:[&>*:not(:last-child)]:mb-0";
    } else if (v === "lg") {
      return "sm:[&>*:not(:last-child)]:mb-8";
    } else if (v === "md") {
      return "sm:[&>*:not(:last-child)]:mb-4";
    } else if (v === "sm") {
      return "sm:[&>*:not(:last-child)]:mb-2";
    } else if (v === "xs") {
      return "sm:[&>*:not(:last-child)]:mb-1";
    } else {
      return "";
    }
  };
  let mdTokenX = v => {
    if (v === "zero") {
      return "md:[&>*:not(:last-child)]:mr-0";
    } else if (v === "lg") {
      return "md:[&>*:not(:last-child)]:mr-8";
    } else if (v === "md") {
      return "md:[&>*:not(:last-child)]:mr-4";
    } else if (v === "sm") {
      return "md:[&>*:not(:last-child)]:mr-2";
    } else if (v === "xs") {
      return "md:[&>*:not(:last-child)]:mr-1";
    } else {
      return "";
    }
  };
  let mdTokenY = v => {
    if (v === "zero") {
      return "md:[&>*:not(:last-child)]:mb-0";
    } else if (v === "lg") {
      return "md:[&>*:not(:last-child)]:mb-8";
    } else if (v === "md") {
      return "md:[&>*:not(:last-child)]:mb-4";
    } else if (v === "sm") {
      return "md:[&>*:not(:last-child)]:mb-2";
    } else if (v === "xs") {
      return "md:[&>*:not(:last-child)]:mb-1";
    } else {
      return "";
    }
  };
  let lgTokenX = v => {
    if (v === "zero") {
      return "lg:[&>*:not(:last-child)]:mr-0";
    } else if (v === "lg") {
      return "lg:[&>*:not(:last-child)]:mr-8";
    } else if (v === "md") {
      return "lg:[&>*:not(:last-child)]:mr-4";
    } else if (v === "sm") {
      return "lg:[&>*:not(:last-child)]:mr-2";
    } else if (v === "xs") {
      return "lg:[&>*:not(:last-child)]:mr-1";
    } else {
      return "";
    }
  };
  let lgTokenY = v => {
    if (v === "zero") {
      return "lg:[&>*:not(:last-child)]:mb-0";
    } else if (v === "lg") {
      return "lg:[&>*:not(:last-child)]:mb-8";
    } else if (v === "md") {
      return "lg:[&>*:not(:last-child)]:mb-4";
    } else if (v === "sm") {
      return "lg:[&>*:not(:last-child)]:mb-2";
    } else if (v === "xs") {
      return "lg:[&>*:not(:last-child)]:mb-1";
    } else {
      return "";
    }
  };
  let xlTokenX = v => {
    if (v === "zero") {
      return "xl:[&>*:not(:last-child)]:mr-0";
    } else if (v === "lg") {
      return "xl:[&>*:not(:last-child)]:mr-8";
    } else if (v === "md") {
      return "xl:[&>*:not(:last-child)]:mr-4";
    } else if (v === "sm") {
      return "xl:[&>*:not(:last-child)]:mr-2";
    } else if (v === "xs") {
      return "xl:[&>*:not(:last-child)]:mr-1";
    } else {
      return "";
    }
  };
  let xlTokenY = v => {
    if (v === "zero") {
      return "xl:[&>*:not(:last-child)]:mb-0";
    } else if (v === "lg") {
      return "xl:[&>*:not(:last-child)]:mb-8";
    } else if (v === "md") {
      return "xl:[&>*:not(:last-child)]:mb-4";
    } else if (v === "sm") {
      return "xl:[&>*:not(:last-child)]:mb-2";
    } else if (v === "xs") {
      return "xl:[&>*:not(:last-child)]:mb-1";
    } else {
      return "";
    }
  };
  let xxlTokenX = v => {
    if (v === "zero") {
      return "2xl:[&>*:not(:last-child)]:mr-0";
    } else if (v === "lg") {
      return "2xl:[&>*:not(:last-child)]:mr-8";
    } else if (v === "md") {
      return "2xl:[&>*:not(:last-child)]:mr-4";
    } else if (v === "sm") {
      return "2xl:[&>*:not(:last-child)]:mr-2";
    } else if (v === "xs") {
      return "2xl:[&>*:not(:last-child)]:mr-1";
    } else {
      return "";
    }
  };
  let xxlTokenY = v => {
    if (v === "zero") {
      return "2xl:[&>*:not(:last-child)]:mb-0";
    } else if (v === "lg") {
      return "2xl:[&>*:not(:last-child)]:mb-8";
    } else if (v === "md") {
      return "2xl:[&>*:not(:last-child)]:mb-4";
    } else if (v === "sm") {
      return "2xl:[&>*:not(:last-child)]:mb-2";
    } else if (v === "xs") {
      return "2xl:[&>*:not(:last-child)]:mb-1";
    } else {
      return "";
    }
  };
  let basePxX = p => {
    if (p === "p6") {
      return "[&>*:not(:last-child)]:mr-1.5";
    } else if (p === "p8") {
      return "[&>*:not(:last-child)]:mr-2";
    } else if (p === "p10") {
      return "[&>*:not(:last-child)]:mr-2.5";
    } else if (p === "p12") {
      return "[&>*:not(:last-child)]:mr-3";
    } else if (p === "p16") {
      return "[&>*:not(:last-child)]:mr-4";
    } else if (p === "p20") {
      return "[&>*:not(:last-child)]:mr-5";
    } else if (p === "p24") {
      return "[&>*:not(:last-child)]:mr-6";
    } else if (p === "p32") {
      return "[&>*:not(:last-child)]:mr-8";
    } else if (p === "p48") {
      return "[&>*:not(:last-child)]:mr-12";
    } else {
      return "[&>*:not(:last-child)]:mr-[5px]";
    }
  };
  let basePxY = p => {
    if (p === "p6") {
      return "[&>*:not(:last-child)]:mb-1.5";
    } else if (p === "p8") {
      return "[&>*:not(:last-child)]:mb-2";
    } else if (p === "p10") {
      return "[&>*:not(:last-child)]:mb-2.5";
    } else if (p === "p12") {
      return "[&>*:not(:last-child)]:mb-3";
    } else if (p === "p16") {
      return "[&>*:not(:last-child)]:mb-4";
    } else if (p === "p20") {
      return "[&>*:not(:last-child)]:mb-5";
    } else if (p === "p24") {
      return "[&>*:not(:last-child)]:mb-6";
    } else if (p === "p32") {
      return "[&>*:not(:last-child)]:mb-8";
    } else if (p === "p48") {
      return "[&>*:not(:last-child)]:mb-12";
    } else {
      return "[&>*:not(:last-child)]:mb-[5px]";
    }
  };
  let smPxX = p => {
    if (p === "p6") {
      return "sm:[&>*:not(:last-child)]:mr-1.5";
    } else if (p === "p8") {
      return "sm:[&>*:not(:last-child)]:mr-2";
    } else if (p === "p10") {
      return "sm:[&>*:not(:last-child)]:mr-2.5";
    } else if (p === "p12") {
      return "sm:[&>*:not(:last-child)]:mr-3";
    } else if (p === "p16") {
      return "sm:[&>*:not(:last-child)]:mr-4";
    } else if (p === "p20") {
      return "sm:[&>*:not(:last-child)]:mr-5";
    } else if (p === "p24") {
      return "sm:[&>*:not(:last-child)]:mr-6";
    } else if (p === "p32") {
      return "sm:[&>*:not(:last-child)]:mr-8";
    } else if (p === "p48") {
      return "sm:[&>*:not(:last-child)]:mr-12";
    } else {
      return "sm:[&>*:not(:last-child)]:mr-[5px]";
    }
  };
  let smPxY = p => {
    if (p === "p6") {
      return "sm:[&>*:not(:last-child)]:mb-1.5";
    } else if (p === "p8") {
      return "sm:[&>*:not(:last-child)]:mb-2";
    } else if (p === "p10") {
      return "sm:[&>*:not(:last-child)]:mb-2.5";
    } else if (p === "p12") {
      return "sm:[&>*:not(:last-child)]:mb-3";
    } else if (p === "p16") {
      return "sm:[&>*:not(:last-child)]:mb-4";
    } else if (p === "p20") {
      return "sm:[&>*:not(:last-child)]:mb-5";
    } else if (p === "p24") {
      return "sm:[&>*:not(:last-child)]:mb-6";
    } else if (p === "p32") {
      return "sm:[&>*:not(:last-child)]:mb-8";
    } else if (p === "p48") {
      return "sm:[&>*:not(:last-child)]:mb-12";
    } else {
      return "sm:[&>*:not(:last-child)]:mb-[5px]";
    }
  };
  let mdPxX = p => {
    if (p === "p6") {
      return "md:[&>*:not(:last-child)]:mr-1.5";
    } else if (p === "p8") {
      return "md:[&>*:not(:last-child)]:mr-2";
    } else if (p === "p10") {
      return "md:[&>*:not(:last-child)]:mr-2.5";
    } else if (p === "p12") {
      return "md:[&>*:not(:last-child)]:mr-3";
    } else if (p === "p16") {
      return "md:[&>*:not(:last-child)]:mr-4";
    } else if (p === "p20") {
      return "md:[&>*:not(:last-child)]:mr-5";
    } else if (p === "p24") {
      return "md:[&>*:not(:last-child)]:mr-6";
    } else if (p === "p32") {
      return "md:[&>*:not(:last-child)]:mr-8";
    } else if (p === "p48") {
      return "md:[&>*:not(:last-child)]:mr-12";
    } else {
      return "md:[&>*:not(:last-child)]:mr-[5px]";
    }
  };
  let mdPxY = p => {
    if (p === "p6") {
      return "md:[&>*:not(:last-child)]:mb-1.5";
    } else if (p === "p8") {
      return "md:[&>*:not(:last-child)]:mb-2";
    } else if (p === "p10") {
      return "md:[&>*:not(:last-child)]:mb-2.5";
    } else if (p === "p12") {
      return "md:[&>*:not(:last-child)]:mb-3";
    } else if (p === "p16") {
      return "md:[&>*:not(:last-child)]:mb-4";
    } else if (p === "p20") {
      return "md:[&>*:not(:last-child)]:mb-5";
    } else if (p === "p24") {
      return "md:[&>*:not(:last-child)]:mb-6";
    } else if (p === "p32") {
      return "md:[&>*:not(:last-child)]:mb-8";
    } else if (p === "p48") {
      return "md:[&>*:not(:last-child)]:mb-12";
    } else {
      return "md:[&>*:not(:last-child)]:mb-[5px]";
    }
  };
  let lgPxX = p => {
    if (p === "p6") {
      return "lg:[&>*:not(:last-child)]:mr-1.5";
    } else if (p === "p8") {
      return "lg:[&>*:not(:last-child)]:mr-2";
    } else if (p === "p10") {
      return "lg:[&>*:not(:last-child)]:mr-2.5";
    } else if (p === "p12") {
      return "lg:[&>*:not(:last-child)]:mr-3";
    } else if (p === "p16") {
      return "lg:[&>*:not(:last-child)]:mr-4";
    } else if (p === "p20") {
      return "lg:[&>*:not(:last-child)]:mr-5";
    } else if (p === "p24") {
      return "lg:[&>*:not(:last-child)]:mr-6";
    } else if (p === "p32") {
      return "lg:[&>*:not(:last-child)]:mr-8";
    } else if (p === "p48") {
      return "lg:[&>*:not(:last-child)]:mr-12";
    } else {
      return "lg:[&>*:not(:last-child)]:mr-[5px]";
    }
  };
  let lgPxY = p => {
    if (p === "p6") {
      return "lg:[&>*:not(:last-child)]:mb-1.5";
    } else if (p === "p8") {
      return "lg:[&>*:not(:last-child)]:mb-2";
    } else if (p === "p10") {
      return "lg:[&>*:not(:last-child)]:mb-2.5";
    } else if (p === "p12") {
      return "lg:[&>*:not(:last-child)]:mb-3";
    } else if (p === "p16") {
      return "lg:[&>*:not(:last-child)]:mb-4";
    } else if (p === "p20") {
      return "lg:[&>*:not(:last-child)]:mb-5";
    } else if (p === "p24") {
      return "lg:[&>*:not(:last-child)]:mb-6";
    } else if (p === "p32") {
      return "lg:[&>*:not(:last-child)]:mb-8";
    } else if (p === "p48") {
      return "lg:[&>*:not(:last-child)]:mb-12";
    } else {
      return "lg:[&>*:not(:last-child)]:mb-[5px]";
    }
  };
  let xlPxX = p => {
    if (p === "p6") {
      return "xl:[&>*:not(:last-child)]:mr-1.5";
    } else if (p === "p8") {
      return "xl:[&>*:not(:last-child)]:mr-2";
    } else if (p === "p10") {
      return "xl:[&>*:not(:last-child)]:mr-2.5";
    } else if (p === "p12") {
      return "xl:[&>*:not(:last-child)]:mr-3";
    } else if (p === "p16") {
      return "xl:[&>*:not(:last-child)]:mr-4";
    } else if (p === "p20") {
      return "xl:[&>*:not(:last-child)]:mr-5";
    } else if (p === "p24") {
      return "xl:[&>*:not(:last-child)]:mr-6";
    } else if (p === "p32") {
      return "xl:[&>*:not(:last-child)]:mr-8";
    } else if (p === "p48") {
      return "xl:[&>*:not(:last-child)]:mr-12";
    } else {
      return "xl:[&>*:not(:last-child)]:mr-[5px]";
    }
  };
  let xlPxY = p => {
    if (p === "p6") {
      return "xl:[&>*:not(:last-child)]:mb-1.5";
    } else if (p === "p8") {
      return "xl:[&>*:not(:last-child)]:mb-2";
    } else if (p === "p10") {
      return "xl:[&>*:not(:last-child)]:mb-2.5";
    } else if (p === "p12") {
      return "xl:[&>*:not(:last-child)]:mb-3";
    } else if (p === "p16") {
      return "xl:[&>*:not(:last-child)]:mb-4";
    } else if (p === "p20") {
      return "xl:[&>*:not(:last-child)]:mb-5";
    } else if (p === "p24") {
      return "xl:[&>*:not(:last-child)]:mb-6";
    } else if (p === "p32") {
      return "xl:[&>*:not(:last-child)]:mb-8";
    } else if (p === "p48") {
      return "xl:[&>*:not(:last-child)]:mb-12";
    } else {
      return "xl:[&>*:not(:last-child)]:mb-[5px]";
    }
  };
  let xxlPxX = p => {
    if (p === "p6") {
      return "2xl:[&>*:not(:last-child)]:mr-1.5";
    } else if (p === "p8") {
      return "2xl:[&>*:not(:last-child)]:mr-2";
    } else if (p === "p10") {
      return "2xl:[&>*:not(:last-child)]:mr-2.5";
    } else if (p === "p12") {
      return "2xl:[&>*:not(:last-child)]:mr-3";
    } else if (p === "p16") {
      return "2xl:[&>*:not(:last-child)]:mr-4";
    } else if (p === "p20") {
      return "2xl:[&>*:not(:last-child)]:mr-5";
    } else if (p === "p24") {
      return "2xl:[&>*:not(:last-child)]:mr-6";
    } else if (p === "p32") {
      return "2xl:[&>*:not(:last-child)]:mr-8";
    } else if (p === "p48") {
      return "2xl:[&>*:not(:last-child)]:mr-12";
    } else {
      return "2xl:[&>*:not(:last-child)]:mr-[5px]";
    }
  };
  let xxlPxY = p => {
    if (p === "p6") {
      return "2xl:[&>*:not(:last-child)]:mb-1.5";
    } else if (p === "p8") {
      return "2xl:[&>*:not(:last-child)]:mb-2";
    } else if (p === "p10") {
      return "2xl:[&>*:not(:last-child)]:mb-2.5";
    } else if (p === "p12") {
      return "2xl:[&>*:not(:last-child)]:mb-3";
    } else if (p === "p16") {
      return "2xl:[&>*:not(:last-child)]:mb-4";
    } else if (p === "p20") {
      return "2xl:[&>*:not(:last-child)]:mb-5";
    } else if (p === "p24") {
      return "2xl:[&>*:not(:last-child)]:mb-6";
    } else if (p === "p32") {
      return "2xl:[&>*:not(:last-child)]:mb-8";
    } else if (p === "p48") {
      return "2xl:[&>*:not(:last-child)]:mb-12";
    } else {
      return "2xl:[&>*:not(:last-child)]:mb-[5px]";
    }
  };
  let dirBase$1 = flexDirection !== undefined ? (
      typeof flexDirection === "object" ? Stdlib_Option.getOr(flexDirection.VAL[0], "column") : (
          flexDirection === "row" ? "row" : "column"
        )
    ) : "column";
  let dirSmVal = typeof flexDirection === "object" && flexDirection.NAME === "responsive" ? flexDirection.VAL[1] : undefined;
  let dirMdVal = typeof flexDirection === "object" && flexDirection.NAME === "responsive" ? flexDirection.VAL[2] : undefined;
  let dirLgVal = typeof flexDirection === "object" && flexDirection.NAME === "responsive" ? flexDirection.VAL[3] : undefined;
  let dirXlVal = typeof flexDirection === "object" && flexDirection.NAME === "responsive" ? flexDirection.VAL[4] : undefined;
  let dirXxlVal = typeof flexDirection === "object" && flexDirection.NAME === "responsive" ? flexDirection.VAL[5] : undefined;
  let spaceClasses;
  if (typeof space === "object") {
    let variant = space.NAME;
    if (variant === "responsive") {
      let match = space.VAL;
      let xxl = match[5];
      let xl = match[4];
      let lg = match[3];
      let md = match[2];
      let sm = match[1];
      let xs = match[0];
      let baseCls;
      if (xs !== undefined) {
        if (typeof xs === "object") {
          if (xs.NAME === "px") {
            let p$1 = xs.VAL;
            baseCls = dirBase$1 === "column" ? basePxY(p$1) : (
                dirBase$1 === "row" ? basePxX(p$1) : ""
              );
          } else {
            baseCls = "";
          }
        } else {
          baseCls = xs === "xs" || xs === "sm" || xs === "md" || xs === "lg" || xs === "zero" ? (
              dirBase$1 === "column" ? baseTokenY(xs) : (
                  dirBase$1 === "row" ? baseTokenX(xs) : ""
                )
            ) : "";
        }
      } else {
        baseCls = "";
      }
      let smCls;
      if (sm !== undefined) {
        if (typeof sm === "object") {
          if (sm.NAME === "px") {
            let p$2 = sm.VAL;
            let match$1 = Stdlib_Option.getOr(dirSmVal, dirBase$1);
            smCls = match$1 === "column" ? smPxY(p$2) : (
                match$1 === "row" ? smPxX(p$2) : ""
              );
          } else {
            smCls = "";
          }
        } else if (sm === "xs" || sm === "sm" || sm === "md" || sm === "lg" || sm === "zero") {
          let match$2 = Stdlib_Option.getOr(dirSmVal, dirBase$1);
          smCls = match$2 === "column" ? smTokenY(sm) : (
              match$2 === "row" ? smTokenX(sm) : ""
            );
        } else {
          smCls = "";
        }
      } else {
        smCls = "";
      }
      let mdCls;
      if (md !== undefined) {
        if (typeof md === "object") {
          if (md.NAME === "px") {
            let p$3 = md.VAL;
            let match$3 = Stdlib_Option.getOr(dirMdVal, Stdlib_Option.getOr(dirSmVal, dirBase$1));
            mdCls = match$3 === "column" ? mdPxY(p$3) : (
                match$3 === "row" ? mdPxX(p$3) : ""
              );
          } else {
            mdCls = "";
          }
        } else if (md === "xs" || md === "sm" || md === "md" || md === "lg" || md === "zero") {
          let match$4 = Stdlib_Option.getOr(dirMdVal, Stdlib_Option.getOr(dirSmVal, dirBase$1));
          mdCls = match$4 === "column" ? mdTokenY(md) : (
              match$4 === "row" ? mdTokenX(md) : ""
            );
        } else {
          mdCls = "";
        }
      } else {
        mdCls = "";
      }
      let lgCls;
      if (lg !== undefined) {
        if (typeof lg === "object") {
          if (lg.NAME === "px") {
            let p$4 = lg.VAL;
            let match$5 = Stdlib_Option.getOr(dirLgVal, Stdlib_Option.getOr(dirMdVal, Stdlib_Option.getOr(dirSmVal, dirBase$1)));
            lgCls = match$5 === "column" ? lgPxY(p$4) : (
                match$5 === "row" ? lgPxX(p$4) : ""
              );
          } else {
            lgCls = "";
          }
        } else if (lg === "xs" || lg === "sm" || lg === "md" || lg === "lg" || lg === "zero") {
          let match$6 = Stdlib_Option.getOr(dirLgVal, Stdlib_Option.getOr(dirMdVal, Stdlib_Option.getOr(dirSmVal, dirBase$1)));
          lgCls = match$6 === "column" ? lgTokenY(lg) : (
              match$6 === "row" ? lgTokenX(lg) : ""
            );
        } else {
          lgCls = "";
        }
      } else {
        lgCls = "";
      }
      let xlCls;
      if (xl !== undefined) {
        if (typeof xl === "object") {
          if (xl.NAME === "px") {
            let p$5 = xl.VAL;
            let match$7 = Stdlib_Option.getOr(dirXlVal, Stdlib_Option.getOr(dirLgVal, Stdlib_Option.getOr(dirMdVal, Stdlib_Option.getOr(dirSmVal, dirBase$1))));
            xlCls = match$7 === "column" ? xlPxY(p$5) : (
                match$7 === "row" ? xlPxX(p$5) : ""
              );
          } else {
            xlCls = "";
          }
        } else if (xl === "xs" || xl === "sm" || xl === "md" || xl === "lg" || xl === "zero") {
          let match$8 = Stdlib_Option.getOr(dirXlVal, Stdlib_Option.getOr(dirLgVal, Stdlib_Option.getOr(dirMdVal, Stdlib_Option.getOr(dirSmVal, dirBase$1))));
          xlCls = match$8 === "column" ? xlTokenY(xl) : (
              match$8 === "row" ? xlTokenX(xl) : ""
            );
        } else {
          xlCls = "";
        }
      } else {
        xlCls = "";
      }
      let xxlCls;
      if (xxl !== undefined) {
        if (typeof xxl === "object") {
          if (xxl.NAME === "px") {
            let p$6 = xxl.VAL;
            let match$9 = Stdlib_Option.getOr(dirXxlVal, Stdlib_Option.getOr(dirXlVal, Stdlib_Option.getOr(dirLgVal, Stdlib_Option.getOr(dirMdVal, Stdlib_Option.getOr(dirSmVal, dirBase$1)))));
            xxlCls = match$9 === "column" ? xxlPxY(p$6) : (
                match$9 === "row" ? xxlPxX(p$6) : ""
              );
          } else {
            xxlCls = "";
          }
        } else if (xxl === "xs" || xxl === "sm" || xxl === "md" || xxl === "lg" || xxl === "zero") {
          let match$10 = Stdlib_Option.getOr(dirXxlVal, Stdlib_Option.getOr(dirXlVal, Stdlib_Option.getOr(dirLgVal, Stdlib_Option.getOr(dirMdVal, Stdlib_Option.getOr(dirSmVal, dirBase$1)))));
          xxlCls = match$10 === "column" ? xxlTokenY(xxl) : (
              match$10 === "row" ? xxlTokenX(xxl) : ""
            );
        } else {
          xxlCls = "";
        }
      } else {
        xxlCls = "";
      }
      spaceClasses = [
        baseCls,
        smCls,
        mdCls,
        lgCls,
        xlCls,
        xxlCls
      ].filter(cls => cls !== "");
    } else if (variant === "px") {
      let p$7 = space.VAL;
      let cls = dirBase$1 === "column" ? basePxY(p$7) : (
          dirBase$1 === "row" ? basePxX(p$7) : ""
        );
      spaceClasses = cls === "" ? [] : [cls];
    } else {
      spaceClasses = [];
    }
  } else if (space === "xs" || space === "sm" || space === "md" || space === "lg" || space === "zero") {
    let cls$1 = dirBase$1 === "column" ? baseTokenY(space) : (
        dirBase$1 === "row" ? baseTokenX(space) : ""
      );
    spaceClasses = cls$1 === "" ? [] : [cls$1];
  } else {
    spaceClasses = [];
  }
  let pClass = Stdlib_Option.flatMap(p, v => mapPadToken("p", v));
  let ptClass = Stdlib_Option.flatMap(pt, v => mapPadToken("pt", v));
  let pbClass = Stdlib_Option.flatMap(pb, v => mapPadToken("pb", v));
  let pxClass = Stdlib_Option.flatMap(px, v => mapPadToken("px", v));
  let mtTokenClass = v => {
    if (v === "lg") {
      return "mt-8";
    } else if (v === "md") {
      return "mt-4";
    } else if (v === "sm") {
      return "mt-2";
    } else if (v === "xs") {
      return "mt-1";
    } else {
      return;
    }
  };
  let mtClassAndStyle;
  if (mt !== undefined) {
    if (typeof mt === "object") {
      let variant$1 = mt.NAME;
      mtClassAndStyle = variant$1 === "px" ? [
          undefined,
          pxToString(mt.VAL)
        ] : (
          variant$1 === "rem" ? [
              undefined,
              mt.VAL.toString() + "rem"
            ] : [
              undefined,
              undefined
            ]
        );
    } else {
      mtClassAndStyle = [
        mtTokenClass(mt),
        undefined
      ];
    }
  } else {
    mtClassAndStyle = [
      undefined,
      undefined
    ];
  }
  let flexClass = hasFlexProps ? ["flex"] : [];
  let alignClasses;
  if (alignItems !== undefined) {
    if (typeof alignItems === "object") {
      let match$11 = alignItems.VAL;
      alignClasses = Belt_Array.concatMany([
        optStrToArr(Stdlib_Option.map(match$11[0], alignBase)),
        optStrToArr(Stdlib_Option.map(match$11[1], alignSm)),
        optStrToArr(Stdlib_Option.map(match$11[2], alignMd)),
        optStrToArr(Stdlib_Option.map(match$11[3], alignLg)),
        optStrToArr(Stdlib_Option.map(match$11[4], alignXl)),
        optStrToArr(Stdlib_Option.map(match$11[5], align2xl))
      ]);
    } else {
      let cls$2 = alignBase(alignItems);
      alignClasses = cls$2 === "" ? [] : [cls$2];
    }
  } else {
    alignClasses = hasFlexProps ? ["items-start"] : [];
  }
  let justifyClasses;
  if (justifyContent !== undefined) {
    let cls$3 = justifyBase(justifyContent);
    justifyClasses = cls$3 === "" ? [] : [cls$3];
  } else {
    justifyClasses = [];
  }
  let directionClasses;
  if (flexDirection !== undefined) {
    if (typeof flexDirection === "object") {
      let match$12 = flexDirection.VAL;
      directionClasses = Belt_Array.concatMany([
        optStrToArr(Stdlib_Option.map(match$12[0], dirBase)),
        optStrToArr(Stdlib_Option.map(match$12[1], dirSm)),
        optStrToArr(Stdlib_Option.map(match$12[2], dirMd)),
        optStrToArr(Stdlib_Option.map(match$12[3], dirLg)),
        optStrToArr(Stdlib_Option.map(match$12[4], dirXl)),
        optStrToArr(Stdlib_Option.map(match$12[5], dir2xl))
      ]);
    } else {
      let cls$4 = dirBase(flexDirection);
      directionClasses = cls$4 === "" ? [] : [cls$4];
    }
  } else {
    directionClasses = [];
  }
  let growClass = flexGrow !== undefined ? (
      flexGrow > 0 ? "grow" : "grow-0"
    ) : undefined;
  let mtStyleVal = mtClassAndStyle[1];
  let headArr = Belt_Array.concatMany([
    flexClass,
    directionClasses,
    alignClasses,
    justifyClasses,
    spaceClasses
  ]);
  let head = Js_array.joinWith(" ", headArr);
  let computedClasses = TailwindMerge.twMerge([
    head,
    Stdlib_Option.getOr(pClass, ""),
    Stdlib_Option.getOr(ptClass, ""),
    Stdlib_Option.getOr(pbClass, ""),
    Stdlib_Option.getOr(pxClass, ""),
    Stdlib_Option.getOr(mtClassAndStyle[0], ""),
    Stdlib_Option.getOr(growClass, ""),
    Stdlib_Option.getOr(props.className, "")
  ]);
  let s = {};
  let w = Stdlib_Option.map(props.width, $$eval);
  let s$1 = w !== undefined ? ReactDOMStyle.unsafeAddProp(s, "width", w) : s;
  let b = Stdlib_Option.map(flexBasis, $$eval$1);
  let s$2 = b !== undefined ? ReactDOMStyle.unsafeAddProp(s$1, "flexBasis", b) : s$1;
  let s$3 = mtStyleVal !== undefined ? ReactDOMStyle.unsafeAddProp(s$2, "marginTop", mtStyleVal) : s$2;
  let s$4;
  if (typeof p === "object") {
    let variant$2 = p.NAME;
    s$4 = variant$2 === "px" ? ReactDOMStyle.unsafeAddProp(s$3, "padding", pxToString(p.VAL)) : (
        variant$2 === "rem" ? ReactDOMStyle.unsafeAddProp(s$3, "padding", p.VAL.toString() + "rem") : s$3
      );
  } else {
    s$4 = s$3;
  }
  let s$5;
  if (typeof pt === "object") {
    let variant$3 = pt.NAME;
    s$5 = variant$3 === "px" ? ReactDOMStyle.unsafeAddProp(s$4, "paddingTop", pxToString(pt.VAL)) : (
        variant$3 === "rem" ? ReactDOMStyle.unsafeAddProp(s$4, "paddingTop", pt.VAL.toString() + "rem") : s$4
      );
  } else {
    s$5 = s$4;
  }
  let s$6;
  if (typeof pb === "object") {
    let variant$4 = pb.NAME;
    s$6 = variant$4 === "px" ? ReactDOMStyle.unsafeAddProp(s$5, "paddingBottom", pxToString(pb.VAL)) : (
        variant$4 === "rem" ? ReactDOMStyle.unsafeAddProp(s$5, "paddingBottom", pb.VAL.toString() + "rem") : s$5
      );
  } else {
    s$6 = s$5;
  }
  let s$7;
  if (typeof px === "object") {
    let variant$5 = px.NAME;
    s$7 = variant$5 === "px" ? ReactDOMStyle.unsafeAddProp(s$6, "paddingLeft", pxToString(px.VAL)) : (
        variant$5 === "rem" ? ReactDOMStyle.unsafeAddProp(s$6, "paddingLeft", px.VAL.toString() + "rem") : s$6
      );
  } else {
    s$7 = s$6;
  }
  let s$8;
  if (typeof px === "object") {
    let variant$6 = px.NAME;
    s$8 = variant$6 === "px" ? ReactDOMStyle.unsafeAddProp(s$7, "paddingRight", pxToString(px.VAL)) : (
        variant$6 === "rem" ? ReactDOMStyle.unsafeAddProp(s$7, "paddingRight", px.VAL.toString() + "rem") : s$7
      );
  } else {
    s$8 = s$7;
  }
  return JsxRuntime.jsx("div", {
    children: children !== undefined ? children : null,
    className: computedClasses,
    style: s$8
  });
}

let make = ViewStack;

exports.pxToString = pxToString;
exports.percentToString = percentToString;
exports.Width = Width;
exports.FlexBasis = FlexBasis;
exports.make = make;
/* tailwind-merge Not a pure module */
